import { getPromo } from '../promos';

import Carousel from "react-multi-carousel";
import { PromoHeading } from './promoMidSection';

const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 1,
            slidesToSlide: 1 // optional, default to 1.
        }
    };

export const LandingHeader = (props) => {
    const promo = getPromo(props.sportKey);
    const headline = props.headline || "Real-time feedback and analysis";
    const subHeading = props.subHeading;
    const images = props.images || [];
    return (<section className="atf-hero-area atf-shape black-smoke-background" style={{ background: 'linear-gradient(to bottom, transparent, transparent, rgba(255,255,255,1)), url(./assets/img/smokebg_dark_compressed.jpg)', backgroundRepeat: 'no-repeat' }}>
                        <div className="non-landing-banner-clear"></div>
                            <div className="container">
                                <div className="row justify-content-center clearfix">
                                        <div className="d-none d-lg-block col-lg-8 col-0 text-center align-self-center atf-single-details pt-3">
                                            <h2 style={{ marginTop: '30px', marginBottom: '0px', color:"white", fontFamily: 'Comfortaa' }}>{headline}</h2>
                                            <h2 style={{ margin: '0px', color:"yellowgreen", fontFamily: 'Comfortaa' }}>{subHeading}</h2>
                                            <div className="mt-5">
                                                <PromoHeading promo={promo} />
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-12 text-center atf-single-details pb-3">
                                        <div className="d-none d-lg-block" style={{height:'20px'}}></div>
                                        <h2 className="heading-size d-block d-lg-none" style={{ marginTop: '30px', color:"white", fontFamily: 'Comfortaa', paddingTop: '10px' }}>{headline}</h2>
                                        <h2 className="d-block d-lg-none" style={{ margin: '0px', marginBottom: '10px',  color:"yellowgreen", fontFamily: 'Comfortaa' }}>{subHeading}</h2>
                                                                                        
                                        <Carousel
                                            swipeable={true}
                                            draggable={true}
                                            showDots={true}
                                            responsive={responsive}
                                            infinite={true}
                                            autoPlay={true}
                                            autoPlaySpeed={2500}
                                            keyBoardControl={true}
                                            customTransition="transform 300ms ease-in-out"
                                            transitionDuration={500}
                                            containerClass="carousel-container"
                                            dotListClass="custom-dot-list-style"
                                            itemClass="carousel-item-padding-40-px"
                                        >
                                            {images.map((image, index) => <div className="px-1" key={index}>
                                                <div className="hero-caption" style={{top: image.captionTop}}>
                                                    <div style={{ margin: '0px 0px 0px 0px', color:"white", fontFamily: 'Comfortaa' }}>{image.caption}</div>
                                                </div>
                                                <img className="hero-carousel-img" style={image.imgStyle} src={image.src} alt={image.alt} />
                                            </div>)}
                                        </Carousel>
                                        </div>
                                    </div>
                                    <div className="d-block d-lg-none row justify-content-center clearfix mt-4">
                                        <div className="text-center align-self-center p-2">
                                            <PromoHeading promo={promo} />
                                        </div>
                                </div>
                            </div>
                        </section>
    
    );
}

export default LandingHeader;